import api from "../api/api";
const normalizeProductsResponse = (response) => {
  if (!response?.data) return [];
  if (Array.isArray(response.data)) return response.data;
  if (Array.isArray(response.data.data)) return response.data.data;
  return [];
};

export const ProductServices = {
  getAllProducts: async () => {
    const res = await api.get("/get-products");
    return normalizeProductsResponse(res);
  },
  getProductById: async (id) => {
    if (!id) throw new Error("Product ID is required");
    const res = await api.get(`/get-product/${id}`);
    if (res?.data?.status && res.data.data) {
      return res.data.data;
    }
    return null;
  },
};
